import { enc } from './core.js';
export function catalogApi(c) {
    const base = (localId) => `/locals/${enc(localId)}`;
    return {
        get: (localId, opts = {}) => c.get(`${base(localId)}/catalog`, { query: { activeOnly: opts.activeOnly ? 1 : undefined } }),
        reorder: (localId, body) => c.post(`${base(localId)}/catalog/reorder`, body),
        createCategory: (localId, body) => c.post(`${base(localId)}/categories`, body),
        updateCategory: (localId, categoryId, body) => c.patch(`${base(localId)}/categories/${enc(categoryId)}`, body),
        deleteCategory: (localId, categoryId) => c.delete(`${base(localId)}/categories/${enc(categoryId)}`),
        createItem: (localId, body) => c.post(`${base(localId)}/items`, body),
        updateItem: (localId, itemId, body) => c.patch(`${base(localId)}/items/${enc(itemId)}`, body),
        deleteItem: (localId, itemId) => c.delete(`${base(localId)}/items/${enc(itemId)}`),
        setItemAvailability: (localId, itemId, body) => c.patch(`${base(localId)}/items/${enc(itemId)}/availability`, body),
        createVariant: (localId, itemId, body) => c.post(`${base(localId)}/items/${enc(itemId)}/variants`, body),
        updateVariant: (localId, variantId, body) => c.patch(`${base(localId)}/variants/${enc(variantId)}`, body),
        deleteVariant: (localId, variantId) => c.delete(`${base(localId)}/variants/${enc(variantId)}`),
    };
}
//# sourceMappingURL=catalog.js.map